import Check from '../../SidePanel/RightPanel/PropertiesControllerCheck.jsx'
import Number from '../../SidePanel/RightPanel/PropertiesControllerNumber.jsx'
import {PropertiesPane} from '../components/NodePropertiesPane.jsx'
import DataType from './PropertiesControllerDataType.jsx'
import DfPrecision from './PropertiesControllerDfPrecision.jsx'
import ButtonMakeFk from './PropertiesPaneButtonMakeFk.jsx'
import Model from './ModelDf.mjs'

const PropertiesPaneBatchDf = (props) => (
    <PropertiesPane
        buttons={<ButtonMakeFk />}

        controllers={
            <>
                <DataType />

                <Number
                    int
                    min={1}
                    prop="dfLen"
                />

                <DfPrecision />
                <Check prop="isPk" />
                <Check prop="isBk" />
                <Check prop="isNull" />
                <Check prop="isTcField" />
            </>
        }

        Model={Model}
        {...props}
    />
)

export default PropertiesPaneBatchDf
